import React from 'react'
import {motion} from 'framer-motion'
// import Moveable from 'react-moveable'

import './Header.scss'
import { AppWraper } from '../../Wrappers'
import {images} from '../../constants'


// const scaleVariants = {
//   whileInView: {
//     scale: [0,1],
//     opacity: [0,1],
//     transition: {
//       duration: 1,
//       ease: 'easeInOut'
//     }
//   }
// }

const Header = () => {

  return (
    <div id='home' className='app__header app__flex'>
      <div className="area app__primarybg" >
        <ul className="circles">
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
          <img src={images.circle} alt="" />
        </ul>
        <motion.div
        whileInView={{x:[-100,0],opacity:[0,1]}}
        transition={{duration:0.85, ease: 'easeOut'}}
        className='app__header-info'
        >
          <div className='app__header-badge'>
            <div className='badge-cmp  app_flex box_shadow'>
              <span>👋</span>
              <div style={{marginLeft: 20}}>
                <p className='p-text'>Hello, I am</p>
                <h1 className='head-text'>Saurabh</h1>
              </div>
            </div>
            <div className="tag-cmp app__flex box_shadow">
              <p className='p-text'>Web Developer</p>
              <p className='p-text'>Freelancer</p>
            </div>
          </div>
        </motion.div>
      </div>
      {/* <motion.div 
      whileInView={{opacity:[0,1]}}
      transition={{duration:0.5,delayChildren: 0.5}}
      className='app__header-img'
      >
        <img src={images.profile} alt="profile_bg" />
        <motion.img
        whileInView={{scale:[0,1]}}
        transition={{duration:1,ease: easeInOut}}
        src={images.circle}
        alt='profile_circle'
        className='overlay_circle'
        />
      </motion.div> */}

      {/* <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className='app__header-circles'
      >
        {[images.flutter,images.redux, images.sass,].map((circle,index)=>(
          <div className='circle-cmp app__flex' key={`circle${index}`}>
            <motion.img 
            whileInView={{scale:[0,1]}}
            transition={{duration:1,ease: easeInOut}}
            src={circle} alt={circle}/>
          </div>
        ))}
      </motion.div> */}
    </div>
  )
}

export default AppWraper(Header,'Home')